import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import {
  FaPlusCircle,
  FaTachometerAlt,
  FaUsers,
  FaEnvelope,
  FaFileAlt,
  FaClipboardList,
  FaQuestionCircle,
} from "react-icons/fa";
import logo from '../../../assets/Icons/QuesthireBlack.png'


const EmployerSidebar = () => {
  const menu = [
    { label: "Post a Job", icon: <FaPlusCircle />, path: "/employer/post-job" },
    {
      label: "Dashboard",
      icon: <FaTachometerAlt />,
      path: "/employer/dashboard",
    },
    { label: "Jobs", icon: <FaClipboardList />, path: "/employer/jobs" },
    { label: "Candidates", icon: <FaUsers />, path: "/employer/candidates" },
    { label: "Messages", icon: <FaEnvelope />, path: "/employer/messages" },
    {
      label: "Resume Database",
      icon: <FaFileAlt />,
      path: "/employer/resume-db",
    },
    // { label: "Activate", icon: <FaPlusCircle />, path: "/employer/activate" },
    // { label: "Help", icon: <FaQuestionCircle />, path: "/employer/help" },
  ];

  return (
    <div className="flex">
      <aside className="w-64 bg-white border-r h-screen py-6 px-4">
        <div className="text-lg font-bold mb-8 pl-2">
          {" "}
          <div className="absolute -left-2 top-8 -translate-y-1/2">
            <img src={logo} alt="logo" className="h-36 w-36 object-contain" />
          </div>
        </div>
        <nav className="space-y-2">
          {menu.map((item, idx) => (
            <NavLink
              key={idx}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2 rounded-lg text-sm font-medium ${isActive
                  ? "bg-black text-white"
                  : "text-gray-700 hover:bg-gray-100"
                }`
              }
            >
              {item.icon}
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      <Outlet />
    </div>
  );
};

export default EmployerSidebar;
